//*************************** Weather Capabilities *********************************// 
// http://geo.weather.gc.ca/geomet/?lang=E&service=WMS&request=GetCapabilities
//**********************************************************************************//

//var AERIS_API_KEY = "59XAPBKIogTz9N3qj5P8x";
//var AERIS_API_SECRET = "KR2ZIfJi3oMhHdWxc5jwfqlEAGoa1lIRhSB3u7de";

//--- Legend Images ---//

//Temperature
var legendTemperature = "//geo.weather.gc.ca/geomet-beta?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=GDPS.ETA_TT&format=image/png&STYLE=TEMPERATURE";

//Weather Alerts
var legendAlerts = "//geo.weather.gc.ca/geomet-beta?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=ALERTS&format=image/png&STYLE=ALERTS";

//Current Conditions
var legendCurrentCondtions = "//geo.weather.gc.ca/geomet-beta?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=CURRENT_CONDITIONS&format=image/png&STYLE=default";

//RADAR - Radar reflectivity (Rain)
var legendRDBR = "//geo.weather.gc.ca/geomet/?LANG=E%26SERVICE=WMS%26VERSION=1.1.1%26REQUEST=GetLegendGraphic%26STYLE=RADARURPREFLECTR%26LAYER=RADAR_RDBR%26format=image/png";

//RADAR - Radar reflectivity (Snow)
var legendRDBS = "//geo.weather.gc.ca/geomet/?LANG=E%26SERVICE=WMS%26VERSION=1.1.1%26REQUEST=GetLegendGraphic%26STYLE=RADARURPREFLECTS%26LAYER=RADAR_RDBS%26format=image/png";

//RADAR - Radar precipitation rate (Rain)
var legendRRAI = "//geo.weather.gc.ca/geomet/?LANG=E%26SERVICE=WMS%26VERSION=1.1.1%26REQUEST=GetLegendGraphic%26STYLE=RADARURPPRECIPR%26LAYER=RADAR_RRAI%26format=image/png";

//RADAR - Radar precipitation rate (Snow)
var legendRSNO = "//geo.weather.gc.ca/geomet/?LANG=E%26SERVICE=WMS%26VERSION=1.1.1%26REQUEST=GetLegendGraphic%26STYLE=RADARURPPRECIPR%26LAYER=RADAR_RSNO%26format=image/png";

//WIND - Wind Arrows in Knots
var legendWIND = "//geo.weather.gc.ca/geomet-beta?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=GDPS.ETA_UU&STYLE=WINDARROW&format=image/png";

//--- End Legend Images ---//  




//--------------- Weather Layers ------------------//

//Temperature
var temperatureLayer = L.tileLayer.wms('//geo.weather.gc.ca/geomet/', {
    format: 'image/png',
    transparent: true,
    layers: 'GDPS.ETA_TT'
});

//Wind

var windLayer = L.tileLayer.wms('//geo.weather.gc.ca/geomet/', {
    format: 'image/png',
    transparent: true,
    layers: 'GDPS.ETA_UU'
});


//Current Conditions (Canada Only)
var currentConditionsLayer = L.tileLayer.wms('//geo.weather.gc.ca/geomet-beta/', {
    format: 'image/png',
    transparent: true,
    layers: 'CURRENT_CONDITIONS'
});

//Alerts (Canada Only)
var weatherAlertsLayer = L.tileLayer.wms('//geo.weather.gc.ca/geomet-beta/', {
    format: 'image/png',
    transparent: true,
    layers: 'ALERTS'
});
/*
var aerisRadarLayer = L.tileLayer('//maps.aerisapi.com/' + AERIS_API_KEY + '_' + AERIS_API_SECRET + '/radar:50/{z}/{x}/{y}/current.png', {
    subdomains: '1234',
    attribution: '&copy;AerisWeather',
});

//RADAR_RDBR: Rain mode reflectivity (dbz)
var internationalRainRadarLayer = L.tileLayer.wms('//geo.weather.gc.ca/geomet/', {
    styles: 'RADARURPREFLECTR',
    format: 'image/png',
    transparent: true,
    layers: 'RADAR_RDBR'
});

//RADAR_RDBS: Snow mode reflectivity (mm/hr)
var internationalSnowRadarLayer = L.tileLayer.wms('//geo.weather.gc.ca/geomet/', {
    styles: 'RADARURPREFLECTS',
    format: 'image/png',
    transparent: true,
    layers: 'RADAR_RDBS'
});

//RADAR_RRAI: Rain precipitation rate (mm/hr)
var internationalRainRateRadarLayer = L.tileLayer.wms('//geo.weather.gc.ca/geomet/', {
    styles: 'RADARURPPRECIPR',
    format: 'image/png',
    transparent: true,
    layers: 'RADAR_RRAI'
});

//RADAR_RSNO: Snow precipitation rate (cm/hr)
var internationalSnowRateRadarLayer = L.tileLayer.wms('//geo.weather.gc.ca/geomet/', {
    styles: 'RADARURPPRECIPS',
    format: 'image/png',
    transparent: true,
    layers: 'RADAR_RSNO'
});
*/
// ------- wrap layers in time dimension layers -------//

//wrapping layers in time dimension layers allows playback using the time dimension control
/*
//time dimension snow rate layer
var internationalTimeSnowRateRadarLayer = L.timeDimension.layer.wms(
    internationalSnowRateRadarLayer, {
        setDefaultTime: true,      //set current time according to getCapabilities
        requestTimeFromCapabilities: true //get time the get Capabilities call

    });

//time dimension rain rate layer
var internationalTimeRainRateRadarLayer = L.timeDimension.layer.wms(internationalRainRateRadarLayer, {
    setDefaultTime: true,              //set current time according to getCapabilities
    requestTimeFromCapabilities: true  //get time the get Capabilities call
});
*/



//--------------- End Weather Layers ------------------//

//weather names 
var windLayerTrans = 'Wind';
var weatherAlertsLayerTrans = 'Weather Alerts';
var currentConditionsLayerTrans = 'Current Weather';
//var aerisRadarLayerTrans = 'Radar';
//var internationalRainRateRadarLayerTrans = 'Radar (Rain)';
//var internationalSnowRateRadarLayerTrans = 'Radar (Snow)';

//var internationalTimeSnowRadarLayer = L.timeDimension.layer.wms(internationalSnowRadarLayer);
//var internationalTimeRainRateRadarLayer = L.timeDimension.layer.wms(internationalRainRateRadarLayer);



// //Weather Overlays
var weatherOverlays = {};
weatherOverlays[windLayerTrans] = windLayer;
weatherOverlays[weatherAlertsLayerTrans] = weatherAlertsLayer;
weatherOverlays[currentConditionsLayerTrans] = currentConditionsLayer;
//weatherOverlays[aerisRadarLayerTrans] = aerisRadarLayer;
//weatherOverlays[internationalRainRateRadarLayerTrans] = internationalTimeRainRateRadarLayer;
//weatherOverlays[internationalSnowRateRadarLayerTrans] = internationalTimeSnowRateRadarLayer;
var weatherAlert;
var cloudCoverLayer;

var timeControl;


//holds the names of the layers that require the time control
//when there are no names in the list the time control gets removed from the map
var timeControlLayers = []; 

L.Control.Weather = L.Control.extend({


    // @section
    // @aka Control.Layers options
    options: {
        // @option collapsed: Boolean = true
        // If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
        collapsed: true,
        position: 'topright',

        // @option autoZIndex: Boolean = true
        // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
        autoZIndex: true,

        // @option hideSingleBase: Boolean = false
        // If `true`, the base layers in the control will be hidden when there is only one.
        hideSingleBase: false
    },

    initialize: function (baseLayers, overlays, options) {
        L.setOptions(this, options);

        //add weather layers as overlays
        overlays = weatherOverlays;

        //Cloud cover is a dynamic layer and needs to be added here instead of 
        //with the WMS layers
     
        cloudCoverLayer = L.esri.dynamicMapLayer({
            url: '//nowcoast.noaa.gov/arcgis/rest/services/nowcoast/sat_meteo_imagery_goes_time/MapServer',
            useCors: false,
            layers: [11],
            opacity: 0.8,
            f: 'image'
        });
        
        overlays['Satellite Cloud Cover'] = cloudCoverLayer;

        this._layers = [];
        this._lastZIndex = 10;   //init to 10 so that weather layers are on top
        this._handlingClick = false;

        //Add baselayers
        for (var i in baseLayers) {
            this._addLayer(baseLayers[i], i);
        }

        //Add overlays
        for (i in overlays) {
            this._addLayer(overlays[i], i, true);
        }
    },
   
   
    onAdd: function (map) {


        this._initLayout();

        this._update();

        this._map = map;
      
        map.on('click', function (e) {

            //Check if the Alerts layer is on the map
            //If it is, show weather alert popup
            map.eachLayer(function (layer) {
                if (layer.wmsParams) {
                    var params = layer.wmsParams;
                    if (params.layers === 'ALERTS') {
                        getAlertInfoAtPoint(e.latlng, map);
                       
                    }
                }
            });
        });

        
        //Update the cloud layer by the time control 
        map.timeDimension.on('timeload', function (data) {
            var date = new Date(map.timeDimension.getCurrentTime());

            if (data.time == map.timeDimension.getCurrentTime())
            {
                var totalTimes = map.timeDimension.getAvailableTimes().length;
                var position = map.timeDimension.getAvailableTimes().indexOf(data.time);
               
                
                if (cloudCoverLayer != null) {
                    cloudCoverLayer.setTimeRange(new Date(date), new Date(date));
                }

            }
        });
        
        timeControl = map.timeDimensionControl;
        map.timeDimensionControl.remove();   //remove the time dimension control since no temporal layers are added at this point

       
        map.on('zoomend', this._checkDisabledLayers, this);

        //Handle overlay Changes

        //Add
        map.on('overlayadd', function (e)
        {
            //Wind
            if (e.name === "Wind") {
                //windLegend.addTo(map);
            }

            //Alerts
            if (e.name === "Weather Alerts") {
                alertsLegend.addTo(map);
            }

            ////Radar
            else if (e.name === "Radar (Snow)") {
            //    snowLegend.addTo(map);
               
                timeControlLayers.push(e.name);  //push name in the list so that the time control gets added to the map
            }
            //Radar
            else if (e.name === "Radar (Rain)") {
            //    rainLegend.addTo(map);
                
                timeControlLayers.push(e.name);
            }
            //Cloud Cover
            if (e.name === "Satellite Cloud Cover") {

                timeControlLayers.push(e.name);
            }

            if (timeControlLayers.length > 0) { timeControl.addTo(map); } //add time control if there are any temporal layers in the list

        });

        //Remove
        map.on('overlayremove', function (e)
        {
            //Wind
            if (e.name === "Wind") {
                //windLegend.remove(map);
            }

            //Alerts
            if (e.name === "Weather Alerts") {
                alertsLegend.remove(map);
            }
            //Radar
            else if (e.name === "Radar (Snow)") {
            //    snowLegend.remove(map);
               
                timeControlLayers.pop(e.name);  //remove name from the list so that the time control gets removed when the list is empty
            }
            //Radar
            else if (e.name === "Radar (Rain)") {
            //    rainLegend.remove(map);
    
                timeControlLayers.pop(e.name);  
            }
            //Cloud Cover
            else if (e.name === "Satellite Cloud Cover") {
                
                timeControlLayers.pop(e.name);  
            }

            if (timeControlLayers.length ==0) { timeControl.remove(); } //remove time control when the list is empty 
        });
 
        //Set the current legend to show
        var currentLegend = legendRDBS;

        //Wind Legend
        var windLegend = L.control({ position: 'bottomright' });
        windLegend.onAdd = function (map) {

            var div = L.DomUtil.create('div', 'info legend');
            div.style.width = '100px';
            div.style.height = '270px';
            div.style.backgroundColor = "#FFFFFF";
            div.innerHTML += '<img src="' + legendWIND + '" alt="legend">';
            return div;
        };

        //Snow Legend
        var snowLegend = L.control({ position: 'topleft' });
        snowLegend.onAdd = function (map) {

            var div = L.DomUtil.create('div', 'info legend');
            div.style.width = '100px';
            div.style.height = '270px';
            div.style.backgroundColor = "#FFFFFF";
            div.innerHTML += '<img src="' + legendRSNO + '" alt="legend">';
            return div;
        };

        //Rain Legend
        var rainLegend = L.control({ position: 'topleft' });
        rainLegend.onAdd = function (map) {

            var div = L.DomUtil.create('div', 'info legend');
            div.style.width = '100px';
            div.style.height = '270px';
            div.style.backgroundColor = "#FFFFFF";
            div.innerHTML += '<img src="' + legendRRAI + '" alt="legend">';
            return div;
        };

        //Alerts Legend
        var alertsLegend = L.control({ position: 'topleft' });
        alertsLegend.onAdd = function (map) {

            var div = L.DomUtil.create('div', 'info legend');
            div.style.width = '100px';
            div.style.height = '70px';
            div.style.backgroundColor = "#FFFFFF";
            div.innerHTML += '<img src="' + legendAlerts + '" alt="legend">';
            return div;
        };

        return this._container;
    },

    

    onRemove: function () {
        this._map.off('zoomend', this._checkDisabledLayers, this);

        for (var i = 0; i < this._layers.length; i++) {
            this._layers[i].layer.off('add remove', this._onLayerChange, this);
        }
    },


    // @method addBaseLayer(layer: Layer, name: String): this
    // Adds a base layer (radio button entry) with the given name to the control.
    addBaseLayer: function (layer, name) {
        this._addLayer(layer, name);
        return (this._map) ? this._update() : this;
    },

    // @method addOverlay(layer: Layer, name: String): this
    // Adds an overlay (checkbox entry) with the given name to the control.
    addOverlay: function (layer, name) {
        this._addLayer(layer, name, true);
        return (this._map) ? this._update() : this;
    },

    // @method removeLayer(layer: Layer): this
    // Remove the given layer from the control.
    removeLayer: function (layer) {
        layer.off('add remove', this._onLayerChange, this);

        var obj = this._getLayer(L.stamp(layer));
        if (obj) {
            this._layers.splice(this._layers.indexOf(obj), 1);
        }
        return (this._map) ? this._update() : this;
    },

    // @method expand(): this
    // Expand the control container if collapsed.
    expand: function () {

        L.DomUtil.addClass(this._container, 'leaflet-control-weather-expanded');

        this._form.style.height = null;

        var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);

        if (acceptableHeight < this._form.clientHeight)
        {
            L.DomUtil.addClass(this._form, 'leaflet-control-weather-scrollbar');
            this._form.style.height = acceptableHeight + 'px';
        }
        else {
            L.DomUtil.removeClass(this._form, 'leaflet-control-weather-scrollbar');
        }
        this._checkDisabledLayers();
        return this;
    },

    // @method collapse(): this
    // Collapse the control container if expanded.
    collapse: function () {
        L.DomUtil.removeClass(this._container, 'leaflet-control-weather-expanded');
        return this;
    },

  
    _initLayout: function () {
        var className = 'leaflet-control-weather',
            container = this._container = L.DomUtil.create('div', className);

        // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
        container.setAttribute('aria-haspopup', true);

        L.DomEvent.disableClickPropagation(container);
        if (!L.Browser.touch) {
            L.DomEvent.disableScrollPropagation(container);
        }

        var form = this._form = L.DomUtil.create('form', className + '-list');

        if (this.options.collapsed) {
            if (!L.Browser.android) {
                L.DomEvent.on(container, {
                    mouseenter: this.expand,
                    mouseleave: this.collapse
                }, this);
            }

            var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Weather';
            //link.style.backgroundImage = 'url(/Home/Content/assets/images/weather.png)';

            if (L.Browser.touch) {
                L.DomEvent
                    .on(link, 'click', L.DomEvent.stop)
                    .on(link, 'click', this.expand, this);
            } else {
                L.DomEvent.on(link, 'focus', this.expand, this);
            }

            // work around for Firefox Android issue https://github.com/Leaflet/Leaflet/issues/2033
            L.DomEvent.on(form, 'click', function () {
                setTimeout(L.bind(this._onInputClick, this), 0);
            }, this);

            this._map.on('click', this.collapse, this);
            // TODO keyboard accessibility
        } else {
            this.expand();
        }

        this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
        this._separator = L.DomUtil.create('div', className + '-separator', form);
        this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);

        container.appendChild(form);
    },

    _getLayer: function (id) {
        for (var i = 0; i < this._layers.length; i++) {

            if (this._layers[i] && L.stamp(this._layers[i].layer) === id) {
                return this._layers[i];
            }
        }
    },

    _addLayer: function (layer, name, overlay) {
        layer.on('add remove', this._onLayerChange, this);

        this._layers.push({
            layer: layer,
            name: name,
            overlay: overlay
        });

        if (this.options.autoZIndex && layer.setZIndex) {
            this._lastZIndex++;
            layer.setZIndex(this._lastZIndex);
        }
    },

    _update: function () {
        if (!this._container) { return this; }

        L.DomUtil.empty(this._baseLayersList);
        L.DomUtil.empty(this._overlaysList);

        var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;

        for (i = 0; i < this._layers.length; i++) {
            obj = this._layers[i];
            this._addItem(obj);
            overlaysPresent = overlaysPresent || obj.overlay;
            baseLayersPresent = baseLayersPresent || !obj.overlay;
            baseLayersCount += !obj.overlay ? 1 : 0;
        }

        // Hide base layers section if there's only one layer.
        if (this.options.hideSingleBase) {
            baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
            this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
        }

        this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';

        return this;
    },

    _onLayerChange: function (e) {
        if (!this._handlingClick) {
            this._update();
        }

        var obj = this._getLayer(L.stamp(e.target));

        // @namespace Map
        // @section Layer events
        // @event baselayerchange: LayersControlEvent
        // Fired when the base layer is changed through the [layer control](#control-layers).
        // @event overlayadd: LayersControlEvent
        // Fired when an overlay is selected through the [layer control](#control-layers).
        // @event overlayremove: LayersControlEvent
        // Fired when an overlay is deselected through the [layer control](#control-layers).
        // @namespace Control.Layers
        var type = obj.overlay ?
            (e.type === 'add' ? 'overlayadd' : 'overlayremove') :
            (e.type === 'add' ? 'baselayerchange' : null);

        if (type) {
            this._map.fire(type, obj);
        }
    },

    // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
    _createRadioElement: function (name, checked) {

        var radioHtml = '<input type="radio" class="leaflet-control-weather-selector" name="' +
                name + '"' + (checked ? ' checked="checked"' : '') + '/>';

        var radioFragment = document.createElement('div');
        radioFragment.innerHTML = radioHtml;

        return radioFragment.firstChild;
    },

    _addItem: function (obj) {
        var label = document.createElement('label'),
            checked = this._map.hasLayer(obj.layer),
            input;

        if (obj.overlay) {
            input = document.createElement('input');
            input.type = 'checkbox';
            input.className = 'leaflet-control-weather-selector';
            input.defaultChecked = checked;
        } else {
            input = this._createRadioElement('leaflet-base-layers', checked);
        }

        input.layerId = L.stamp(obj.layer);

        L.DomEvent.on(input, 'click', this._onInputClick, this);

        var name = document.createElement('span');
        name.innerHTML = ' ' + obj.name;

        // Helps from preventing layer control flicker when checkboxes are disabled
        // https://github.com/Leaflet/Leaflet/issues/2771
        var holder = document.createElement('div');

        label.appendChild(holder);
        holder.appendChild(input);
        holder.appendChild(name);

        var container = obj.overlay ? this._overlaysList : this._baseLayersList;
        container.appendChild(label);

        this._checkDisabledLayers();
        return label;
    },

    _onInputClick: function () {
        var inputs = this._form.getElementsByTagName('input'),
            input, layer, hasLayer;
        var addedLayers = [],
            removedLayers = [];

        this._handlingClick = true;

        for (var i = inputs.length - 1; i >= 0; i--) {
            input = inputs[i];
            layer = this._getLayer(input.layerId).layer;
            hasLayer = this._map.hasLayer(layer);

            if (input.checked && !hasLayer) {
                addedLayers.push(layer);

            } else if (!input.checked && hasLayer) {
                removedLayers.push(layer);
            }
        }

        // Bugfix issue 2318: Should remove all old layers before readding new ones
        for (i = 0; i < removedLayers.length; i++) {
            this._map.removeLayer(removedLayers[i]);
        }
        for (i = 0; i < addedLayers.length; i++) {
            this._map.addLayer(addedLayers[i]);
        }

        this._handlingClick = false;

        this._refocusOnMap();
    },

    _checkDisabledLayers: function () {
        var inputs = this._form.getElementsByTagName('input'),
            input,
            layer,
            zoom = this._map.getZoom();

        for (var i = inputs.length - 1; i >= 0; i--) {
            input = inputs[i];
            layer = this._getLayer(input.layerId).layer;
            input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
                             (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);

        }
    },

    _expand: function () {
        // Backward compatibility, remove me in 1.1.
        return this.expand();
    },

    _collapse: function () {
        // Backward compatibility, remove me in 1.1.
        return this.collapse();
    },



   
});



L.control.weather = function () {
    return new L.Control.Weather();
};
// Weather Alert Popup
var getAlertInfoAtPoint= function (point,map) {
    var i = document.createElement('img');

    var weatherAlertInfoLayer = '//geo.weather.gc.ca/geomet-beta?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetFeatureInfo&BBOX=';


    //create a bbox around the clicked point
    var latLng = L.latLng(point);
    var currentPoint = map.latLngToContainerPoint(latLng);
    var width = 20;
    var height = 15;
    var xDifference = width / 2;
    var yDifference = height / 2;
    var southWest = L.point((currentPoint.x - xDifference), (currentPoint.y - yDifference));
    var northEast = L.point((currentPoint.x + xDifference), (currentPoint.y + yDifference));
    var bounds = L.latLngBounds(map.containerPointToLatLng(southWest), map.containerPointToLatLng(northEast));

    var bbox = [bounds._southWest.lat, bounds._southWest.lng, bounds._northEast.lat, bounds._northEast.lng];

    //Query to get the alert message
    var suffix = '&CRS=EPSG:4326&WIDTH=2&HEIGHT=2&LAYERS=ALERTS&QUERY_LAYERS=ALERTS&INFO_FORMAT=application/vnd.ogc.gml&I=0&J=1&FEATURE_COUNT=1'
    var url = weatherAlertInfoLayer.concat(bbox).concat(suffix);


    weatherAlert = url;

    var HttpClient = function () {
        this.get = function (aUrl, aCallback) {
            var anHttpRequest = new XMLHttpRequest();
            anHttpRequest.onreadystatechange = function () {
                if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
                    aCallback(anHttpRequest.responseText);
            }

            anHttpRequest.open("GET", aUrl, true);
            anHttpRequest.send(null);
        }
    }

    function titleCase(str) {
        words = str.toLowerCase().split(' ');

        for(var i = 0; i < words.length; i++) {
            var letters = words[i].split('');
            letters[0] = letters[0].toUpperCase();
            words[i] = letters.join('');
        }
        return words.join(' ');
    }

    aClient = new HttpClient();
    aClient.get(url, function (response) {
        // do something with response
        //console.log(response);

       //Parse the GML response to build weather popup
        
        var xmlText = $('#featureData').text(),
            $xmlData = $.parseXML(response),
            $features = $('ALERTS_feature', $xmlData),
            extractedFeatures = [];

                $features.each(function () {
                    var $this = $(this),
                        feature = {},
                        //Items to parse
                        items = [
                            'area',
                            'effective',
                            'expires',
                            'descrip_en',
                            'headline',
                            'alert_type',
                            'status'
                        ],
                        item;

                    for (var i = 0; i < items.length; i++) {
                        item = items[i];
                        feature[item] = $this.find(item).text();
                    }
                    //Split the paragraphs
                    var paragraphs = feature['descrip_en'].split("###");
                

                    //Show Weather Popup
                    //var popup = L.popup()
                    //.setLatLng(latLng)
                    //.setContent(
                   
                    //    '<div class="container">' +
                    //     '<div class="jumbotron">' +
                    //        '<h4>' + titleCase(feature['headline']) + '</h4>' +
                    //            '<div>' +
                    //                '<h5>' + titleCase(feature['area']) + '</h5>' +
                    //                '<p>' + paragraphs[0] + '</p>' +
                    //                '<p>' + paragraphs[1] + '</p>' +
                    //                '<h6>Effective: ' + feature['effective'].replace('+00', '') + '</h6>' +
                    //                '<h6>Expires: ' + feature['expires'].replace('+00','') + '</h6>' +
                    //                '<h6>Status: ' + titleCase(feature['status']) + '</h6>' +
                    //            '</div>' +
                    //    '</div>'+
                    //'</div>'
                    //)
                    //.openOn(map);
                });
      
    });
   
}
